import { Image, Linking, StyleSheet, View } from "react-native";
import { fp, hp, spV, wp } from "utils/normalizeV2";

import { Images } from "assets";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import Heading from "components/Heading";

export default function Affiliate() {
    return (
        <ParentScrollView>
            <View style={styles.container}>
                <View style={{ ...styles.heroSection }}>
                    <Image
                        accessibilityLabel="Affiliate Network Image"
                        source={Images.AffiliateNetwork}
                        resizeMode="contain"
                        style={{ width: "auto", height: hp(250) }}
                    />
                    <View style={styles.heroText}>
                        <View style={{ marginVertical: "auto", marginHorizontal: wp(130) }}>
                            <VText style={{ color: "white", fontSize: fp(24), fontWeight: "300", marginBottom: hp(5) }}>
                                Join
                            </VText>
                            <Heading
                                
                                style={{
                                    fontFamily: "LibreBodoni",
                                    color: "white",
                                    fontSize: fp(36),
                                    fontWeight: "450",
                                }}
                            >
                                The Vêtir Affiliate Network
                            </Heading>
                        </View>
                    </View>
                </View>

                <View style={styles.paragraphSection}>
                    <VText style={{ width: "45%", fontSize: fp(16), fontWeight: "350", lineHeight: fp(24) }}>
                        At Vêtir, we are revolutionizing social commerce. We partner with luxury-minded fashion creators
                        who align with our ethos. Join our affiliate network to monetize your influence—with our in-app
                        social integration, it’s easy to share your digital closet and curated style with your
                        community.
                    </VText>

                    <VText style={{ fontSize: fp(24), fontWeight: "500", lineHeight: fp(40), marginTop: hp(10) }}>
                        How It Works
                    </VText>

                    <View style={styles.howItWorksSection}>
                        <View style={{ display: "flex", flexDirection: "row" }}>
                            <VText style={styles.listItem}></VText>
                            <VText style={styles.listItemText}>
                                Download the app to create your account and start adding to your digital closet.
                            </VText>
                        </View>
                        <View style={{ display: "flex", flexDirection: "row" }}>
                            <VText style={styles.listItem}></VText>
                            <VText style={styles.listItemText}>
                                Apply to become a VêtirIP by emailing us at{" "}
                                <VText
                                    onPress={() => {
                                        Linking.openURL("mailto:vetirapp@vetirapp.com");
                                    }}
                                    style={{ fontWeight: "400" }}
                                >
                                    {"Admin@vetirapp.com "}
                                </VText>
                                with your info and social handles or websites. We will review your application and
                                contact you with next steps. 
                            </VText>
                        </View>

                        <View style={{ display: "flex", flexDirection: "row" }}>
                            <VText style={styles.listItem}></VText>
                            <VText style={styles.listItemText}>
                                Start earning commission when your followers purchase through the Vêtir channels using
                                your personalized link. 
                            </VText>
                        </View>
                    </View>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        width: "auto",
    },
    howItWorksSection: {
        marginTop: hp(10),
    },

    listItem: {
        display: "inline-block",
        borderTopWidth: 1,
        borderTopColor: "black",
        width: "45px",
        height: hp(5),
        marginTop: "13px",
    },

    heroSection: {
        height: hp(270),
    },

    heroText: {
        height: hp(250),
        width: "100%",
        position: "absolute",
        top: spV(0),
        fontSize: fp(20),
        fontWeight: "500",
        color: "white",
        backgroundImage: "linear-gradient(to right, #000000, #11111100)",
    },

    paragraphSection: {
        paddingVertical: hp(20),
        paddingHorizontal: wp(130),
    },

    listItemText: {
        fontSize: fp(16),
        fontWeight: "350",
        lineHeight: fp(24),
        marginLeft: wp(25),
        width: "45%",
        marginTop: hp(5),
    },
});
